<template>
  <div class="container">
    <Loading v-show="showLoading" />
    <v-flex xs12 sm12 d-flex>
      <v-card v-if="$store.state.subProject">
        <v-toolbar
          color="light-green lighten-2"
          dark
          style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
          @click="forecastReadyDaily = !forecastReadyDaily"
        >
          <v-toolbar-title
            center
            style="color: white !important; text-align: center !important;"
            class="justify-center"
          >
            <h4 class="text-xs-center">
              <v-icon class="icon">mdi-bug</v-icon>PLAGAS Y ENFREMEDADES
            </h4>
          </v-toolbar-title>
        </v-toolbar>

        <div class="main">
          <v-layout row wrap>
            <v-flex md4 sm4 lg4>
              <h4 class="text-xs-left">Fecha: {{ date }}</h4>
            </v-flex>
            <v-flex md4 sm4 lg4>
              <v-select
                :items="agroUnits"
                name="name"
                item-text="name"
                label="Ubicación"
                @change="selectAgroUnit($event)"
              />
            </v-flex>
          </v-layout>
          <div class="notification" v-if="todayReport">
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on }">
                <br />
                <h3 class="text-xs-center">
                  REPORTE DE HOY ENVIADO!
                </h3>
                <v-btn color="grey lighten-1" dark @click="clickEdit()">
                  EDITAR REPORTE<v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red lighten-1" dark v-on="on">
                  ELIMINAR REPORTE<v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title
                  class="headline grey lighten-2 trash"
                  primary-title
                >
                  ELIMINAR REPORTE<v-icon>mdi-delete</v-icon>
                </v-card-title>
                <v-card-text class="text-xs-center">
                  ¿Estas seguro que quieres eliminar el reporte de hoy?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="dialog = false"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn color="red lighten-1" dark @click="clickDelete()">
                    Eliminar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <v-progress-linear
            v-if="items.length == 0 && this.location !== null"
            v-model="valueDeterminate"
          ></v-progress-linear>
          <template v-if="!todayReport">
            <v-form ref="form" v-model="valid" lazy-validation>
              <div v-for="(tunnel, i) in tunnels" :key="i">
                <h3>{{ tunnels[i].name }}</h3>
                <div class="table" v-if="!todayReport">
                  <v-data-table
                    v-if="tunnels"
                    :headers="headers"
                    :items="tunnel.PlagueReports[0].Findings"
                    :pagination.sync="pagination"
                    class="elevation-1 form"
                  >
                    <template v-slot:items="props" class="old">
                      <tr :class="props.item.new">
                        <td class="text-xs-center">{{ location }}</td>
                        <td class="text-xs-center">{{ week }}</td>
                        <td class="text-xs-center">{{ tunnels[i].name }}</td>
                        <td class="text-xs-center">{{ props.item.line }}</td>
                        <td class="text-xs-center">
                          <v-select
                            v-model="props.item.block"
                            :items="block"
                            outline
                            small
                            class="select"
                            label="Bloque"
                          />
                        </td>
                        <td class="text-xs-center">
                          <v-select
                            v-model="props.item.plagueName"
                            :items="plagas"
                            outline
                            small
                            class="select"
                            label="Plagas"
                          />
                        </td>
                        <td class="text-xs-center">
                          <v-select
                            v-model="props.item.plantLocation"
                            :items="plantLocation"
                            outline
                            small
                            class="select"
                            label="Ubicación"
                          />
                        </td>
                        <td class="text-xs-center">
                          <v-select
                            v-model="props.item.stratus"
                            :items="stratus"
                            outline
                            small
                            class="select"
                            label="Estrato"
                          />
                        </td>
                        <td class="text-xs-center quantity">
                          <v-text-field
                            v-model="props.item.individuals"
                            :rules="[(v) => v > -1 || 'ERROR']"
                            outline
                            class="text-xs-center"
                            type="number"
                            step="1"
                          />
                        </td>
                        <td class="text-xs-center">
                          <v-text-field
                            v-model="props.item.comment"
                            label="..."
                            outline
                          />
                        </td>
                        <td>
                          <v-btn
                            color="blue"
                            fab
                            small
                            dark
                            @click="add(props, i)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </td>
                        <td class="delete" v-if="props.item.new">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn flat @click="remove(props, i)" v-on="on">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>ELIMINAR</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-form>
          </template>
          <div v-if="showSubmit == true">
            <v-btn class="submit" color="green" right block @click="submit()"
              >Finalizar</v-btn
            >
          </div>
          <div v-if="showEdit == true">
            <v-btn class="submit" color="blue" right block @click="edit()"
              >Editar</v-btn
            >
          </div>
          <div v-if="showReSubmit == true">
            <v-btn class="submit" color="blue" right block @click="resubmit()"
              >Re-enviar</v-btn
            >
          </div>
          <br />
        </div>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
const Loading = () => import("../components/resources/Loading.vue");
import moment from "moment-timezone";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      dialog: false,
      showLoading: false,
      showSubmit: false,
      showReSubmit: false,
      showEdit: false,
      date: null,
      headers: [
        {
          text: "Ubicación",
          align: "center",
          // sortable: true,
          value: "ubicacion",
        },
        { text: "Semana", value: "semana" },
        { text: "Túnel", value: "tunel" },
        { text: "Linea", value: "line" },
        { text: "Bloque", value: "bloque" },
        { text: "Hallazgo", value: "hallazgo" },
        { text: "Ubicación", value: "ubicacion" },
        { text: "Estrato", value: "estrato" },
        { text: "Cantidad", value: "intensidad" },
        { text: "Comentarios", value: "comentarios" },
        { text: "Mas", value: "mas" },
      ],
      plagas: [
        "Pulgon",
        "Mosca blanca",
        "Araña roja",
        "Trips",
        "Lepidopteros",
        "Mosca fruta",
        "Roya",
        "Botrytis",

        "Otro",
        "Ninguna",
      ],
      pagination: {
        rowsPerPage: 20,
      },
      agroUnits: null,
      agroUnitId: null,
      block: ["ADELANTE", "MEDIO", "ATRAS"],
      stratus: ["ALTO", "MEDIO", "BAJO"],
      plantLocation: [
        "APICE",
        "HOJA HAZ",
        "HOJA ENVEZ",
        "FLOR",
        "FRUTO",
        "CORONA",
        "SUSTRATO",
      ],
      location: null,
      tunnel: null,
      tunnels: null,
      week: null,
      items: [],
      todayReport: false,
      report: {
        name: null,
        week: null,
        createdDate: null,
        agroUnitId: null,
        tunelId: null,
        userId: null,
      },
      valueDeterminate: 50,
      valid: true,
    };
  },
  created: async function() {
    this.date = moment()
      .tz("America/Los_Angeles")
      .locale("es")
      .format("LL");

    this.getWeekNumber(new Date());
    this.plagueReports = this.$store.state.plaguesReports;

    let agroUnitId = this.$store.state.subProjectId;

    await this.$axios
      .get(`/api/parcelByAgroUnit/${agroUnitId}`)
      .then((data) => {
        this.agroUnits = data.data;
      });
  },
  methods: {
    selectAgroUnit: async function(event) {
      this.tunnels = null;
      this.showLoading = true;
      this.todayReport = false;
      this.items = [];
      this.location = event;
      this.agroUnitId = this.agroUnits.find((x) => x.name === event).id;

      await this.$axios
        .get(`/api/tunelByPacerlId/${this.agroUnitId}`)
        .then((data) => {
          // console.log("TUNEL", data.data);
          this.tunnels = data.data;
        });
      this.selectTunnels();
    },
    async selectTunnels() {
      this.showEdit = false;
      let agroUnitIds = [this.agroUnitId];
      let dateA = new Date(new Date(new Date()).setHours(0))
        .toISOString()
        .substr(0, 10);
      let dateB = new Date(new Date(new Date()).setHours(23));

      let payload = {
        agroUnitIds: agroUnitIds,
        date: dateA,
        date2: dateB,
      };

      await this.$axios
        .post(`/api/getTunelsAllDaily/`, payload)
        .then((data) => {
          this.tunnels = data.data;
          console.log("TUNEL", this.tunnels);
        });

      for (const tunnel of this.tunnels) {
        if (tunnel.PlagueReports[0] == undefined) {
          tunnel.PlagueReports = [];
          tunnel.PlagueReports.push({ Findings: [] });
          console.log("chuy", tunnel.PlagueReports);
          tunnel.PlagueReports.push([1]);
          let tunelId = tunnel.id;
          // this.report.tunelId = this.tunelId;
          console.log("Lines", tunnel.line);
          console.log("id", tunelId);

          for (let index = 0; index < tunnel.lines; index++) {
            tunnel.PlagueReports[0].Findings.push({
              test: "test",
              plagueReportId: null,
              line: index + 1,
              plants: "",
              range: 1,
              plagueName: null,
              individuals: 0,
              comment: "",
              location: this.location,
              stratus: "",
              plantLocation: "",
            });
          }
          this.items.push(tunnel);
          this.showSubmit = true;
        } else {
          this.todayReport = true;
          this.showSubmit = false;
          this.items = this.tunnels;
        }
      }

      this.report.week = this.week;
      this.report.createdDate = new Date();
      this.report.agroUnitId = this.agroUnitId;
      // this.report.tunelId = tunelId;
      this.report.userId = this.$store.state.userId;

      this.$store.commit("plaguesReports", this.items);

      this.showLoading = false;
    },
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      // Return array of year and week number
      this.week = weekNo;
    },
    add(event, i) {
      let chuy = event.item;
      console.log("chuy", chuy);
      console.log("location", this.location);
      let newReport = {
        block: chuy.block,
        line: chuy.line,
        plagueName: null,
        individuals: 0,
        location: this.location,
        new: "true",
        stratus: chuy.stratus,
        plantLocation: chuy.plantLocation,
      };

      console.log("items", this.items);
      console.log("item", this.items[i]);

      this.items[i].PlagueReports[0].Findings.insert = function(index, item) {
        this.splice(index, 0, item);
      };
      this.items[i].PlagueReports[0].Findings.insert(
        event.item.line,
        newReport
      );
    },
    remove(event, i) {
      this.items[i].PlagueReports[0].Findings.remove = function(index) {
        this.splice(index, 1);
      };
      this.items[i].PlagueReports[0].Findings.remove(event.item.line);
    },
    clickReSubmit() {
      this.todayReport = false;
      this.showReSubmit = true;
    },
    clickEdit() {
      this.todayReport = false;
      this.showEdit = true;
    },
    clickDelete() {
      this.dialog = false;
      this.tunnels.forEach((tunnels) => {
        console.log("tunnels", tunnels.PlagueReports[0]);
        let reportId = tunnels.PlagueReports[0].id;
        console.log("Report Id", reportId);
        this.deleteReport(reportId);
      });
      alert("Reporte Elimindado!!!");
      this.$router.push({ name: "PlagasEnfermedades" });
    },
    deleteReport(reportId) {
      let id = reportId;
      this.$axios.post(`/api/DeletePlaguesReports/`, { id }).then((data) => {
        console.log(data.data);
      });
    },
    edit: async function() {
      this.showLoading = true;
      let counter = 0;
      for (const tunnels of this.tunnels) {
        console.log("tunnels", tunnels.PlagueReports[0]);
        let reportId = tunnels.PlagueReports[0].id;
        console.log("Report Id", reportId);
        let id = reportId;
        await this.$axios
          .post(`/api/DeletePlaguesReports/`, { id })
          .then((data) => {
            console.log(data.data);
          });
        counter++;
      }
      console.log(counter);
      if (counter == this.tunnels.length) {
        console.log("submit", this.tunnels.length);
        this.submit();
        alert("Reporte Actualizado!!!");
      }
    },
    resubmit: async function() {
      this.showLoading = true;
      // let counter = 0;
      for (const tunnels of this.tunnels) {
        console.log("tunnels", tunnels.PlagueReports[0]);
        if (tunnels.PlagueReports[0].id) {
          let reportId = tunnels.PlagueReports[0].id;
          console.log("Report Id", reportId);
          let id = reportId;
          await this.$axios
            .post(`/api/DeletePlaguesReports/`, { id })
            .then((data) => {
              console.log(data.data);
            });
          // counter++;
        }
      }
      // console.log(counter);
      // if (counter == this.tunnels.length) {
      console.log("submit", this.tunnels.length);
      this.submit();
      alert("Reporte Actualizado!!!");
      // }
    },
    submit: async function() {
      if (this.$refs.form.validate()) {
        // this.dialog = false;
        // this.showLoading = true;
        this.showSubmit = false;

        console.log("Items", this.items);
        console.log("Tunnels", this.tunnels);
        let counter = 0;
        let StatusCounter = 0;

        for (const tunnel of this.tunnels) {
          const newReport = { ...this.report };
          newReport.tunelId = tunnel.id;

          console.log("id", tunnel.id);
          console.log("Report", newReport);
          console.log("test", this.items[counter].PlagueReports[0].Findings);

          try {
            await this.$axios
              .post(`/api/PlaguesReports`, newReport)
              .then((data) => {
                console.log("data", this.tunnels.length, counter, data);

                if (data.status == "200") {
                  StatusCounter++;
                }

                let PlagueReportId = data.data.id;
                tunnel.PlagueReports[0].id = PlagueReportId;
                this.items[counter].PlagueReports[0].Findings.forEach(
                  (item) => {
                    item.plagueReportId = PlagueReportId;
                  }
                );
                this.$axios
                  .post(
                    `/api/Findings`,
                    this.items[counter].PlagueReports[0].Findings
                  )
                  .then((data) => {
                    console.log("response", data);
                  });
              });
            counter++;

            if (
              StatusCounter == this.tunnels.length ||
              StatusCounter == counter + 1
            ) {
              this.todayReport = this.items;
              this.$store.commit("plaguesReports", this.items);
              this.showLoading = false;
              this.$router.push({ name: "PlagasEnfermedades" });
              alert("Reporte Enviado Exitosamente!!!", counter);
            }
          } catch (error) {
            alert("ERROR EN CONEXIÓN VUELVE A ENVIAR EL REPORTE");
            const { response } = error;
            console.log(response);
            this.clickReSubmit();
            return;
          }

          console.log("statuscounter", StatusCounter);
        }
      }
    },
  },
};
</script>

<style scoped>
.main {
  padding: 30px !important;
}

.trash {
  background-color: red;
}

.icon {
  margin-right: 10px;
}

.notification {
  display: block;
  margin-left: 30% !important;
}

.form {
  transform: scale(0.85);
  transform-origin: 0% 0% 0px;
  /* margin-left: 0px !important;
  padding-left: 0px !important; */
}

.table {
  border-radius: 3px;
}

tr {
  height: 20px !important;
}

.old:hover {
  border: 1px solid blue !important;
}

.true {
  background-color: lightblue !important;
}

.quantity {
  width: 5%;
}

.delete {
  width: 1%;
  padding: 0px !important;
}

.v-input {
  top: 15px !important;
}

input {
  font-size: 20px !important;
  height: 30px !important;
}

.submit {
  float: right;
  margin-top: -5%;
}
</style>
